import { createSlice } from "@reduxjs/toolkit";

import { getProgramData } from "../../services/api/robot";
import { getFromS3URL } from "../../services/api";

import { novDataLogs } from "../../libs/utils";

const logsSlice = createSlice({
  name: "novdata_logs",
  initialState: {
    fetching: false,
    fetchingError: null,
  },

  reducers: {
    fetchListRequest: (state) => ({
      ...state,
      fetching: true,
      fetchingError: null,
    }),

    fetchListFailure: (state, action) => ({
      ...state,
      fetching: false,
      fetchingError: action.error,
    }),

    fetchListSuccess: (state, action) => ({
      ...state,
      fetching: false,
      fetchingError: null,
      logs: action.payload.logs,
    }),

    fetchRequest: (state) => ({
      ...state,
      fetching: true,
      fetchingError: null,
    }),

    fetchFailure: (state, action) => ({
      ...state,
      fetching: false,
      fetchingError: action.error,
    }),

    fetchSuccess: (state, action) => ({
      ...state,
      fetching: false,
      fetchingError: null,
      selectedItem: action.payload.selectedItem,
    }),
  },
});

export const {
  fetchListRequest,
  fetchListFailure,
  fetchListSuccess,
  fetchRequest,
  fetchFailure,
  fetchSuccess,
} = logsSlice.actions;

export default logsSlice.reducer;

export const getRobotNovDataLogs = (id) => async (dispatch) => {
  try {
    dispatch(fetchListRequest());

    const { data } = await getProgramData(id === "171" ? 1 : id, "novdata_logs");

    const logs = novDataLogs(data);

    dispatch(fetchListSuccess({ logs }));
  } catch (err) {
    dispatch(fetchListFailure(err.toString()));
  }
};

export const getRobotNovDataLog = (url) => async (dispatch) => {
  try {
    dispatch(fetchRequest());

    const tsv = await getFromS3URL(url);

    dispatch(fetchSuccess({ selectedItem: tsv }));
  } catch (err) {
    dispatch(fetchFailure(err.toString()));
  }
};
